/* Auto-advance for the product gallery rail (sections/lrn-gallery.liquid).
 *
 * THE RAIL WORKS WITHOUT THIS FILE. It is a real scroll container with CSS
 * scroll-snap, so it swipes on touch and scrolls by keyboard on its own. What
 * this adds is the auto-advance and the two arrow buttons - progressive
 * enhancement, not the mechanism. If this script fails to load, the section
 * degrades to a swipeable rail rather than to a broken one.
 *
 * IT STOPS MOVING WHENEVER A PERSON MIGHT BE READING IT:
 *   - prefers-reduced-motion: never starts, and the listener means a visitor who
 *     changes the setting mid-visit is obeyed without a reload
 *   - pointer over the rail, or focus anywhere inside it (keyboard users get the
 *     same courtesy as mouse users, which is the half usually missed)
 *   - the rail is scrolled off-screen
 *   - the tab is hidden, so a backgrounded tab is not animating for nobody
 *
 * WHY scrollBy AND NOT AN INDEX. Slide width is a CSS decision that changes at
 * every breakpoint, so tracking "which slide" in JS means keeping a second copy
 * of the layout here and watching it drift. Measuring the first slide at the
 * moment of the scroll asks the browser what the layout actually is.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(root) {
    if (root.dataset.lrnGalleryReady === 'true') return;
    root.dataset.lrnGalleryReady = 'true';

    var rail = root.querySelector('.lrn-gallery__rail');
    if (!rail) return;

    var prev = root.querySelector('[data-lrn-gallery-prev]');
    var next = root.querySelector('[data-lrn-gallery-next]');
    var seconds = parseInt(root.dataset.autoplay, 10);
    var timer = null;
    var onScreen = true;
    var held = false;

    function step() {
      var slide = rail.querySelector('.lrn-gallery__slide');
      if (!slide) return rail.clientWidth;
      // The gap belongs to the step: without it the rail drifts by one gap per
      // advance and the snap points slowly stop lining up with the viewport.
      var gap = parseFloat(getComputedStyle(rail).columnGap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function atEnd() {
      // 2px of slack: sub-pixel layout means scrollLeft rarely lands exactly on
      // the maximum, and an exact comparison leaves the rail stuck one step from
      // the end forever.
      return rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    }

    function advance(direction) {
      var behavior = reduced.matches ? 'auto' : 'smooth';
      if (direction > 0 && atEnd()) {
        rail.scrollTo({ left: 0, behavior: behavior });
        return;
      }
      if (direction < 0 && rail.scrollLeft <= 2) {
        rail.scrollTo({ left: rail.scrollWidth, behavior: behavior });
        return;
      }
      rail.scrollBy({ left: step() * direction, behavior: behavior });
    }

    function shouldRun() {
      return !reduced.matches && seconds > 0 && onScreen && !held &&
             !document.hidden;
    }

    function sync() {
      if (shouldRun()) {
        if (timer === null) timer = window.setInterval(function () {
          advance(1);
        }, seconds * 1000);
      } else if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function hold(state) {
      held = state;
      sync();
    }

    if (prev) prev.addEventListener('click', function () { advance(-1); });
    if (next) next.addEventListener('click', function () { advance(1); });

    root.addEventListener('mouseenter', function () { hold(true); });
    root.addEventListener('mouseleave', function () { hold(false); });
    // focusin/focusout and not focus/blur: these do not bubble from the links
    // inside, and the links are exactly what a keyboard visitor lands on.
    root.addEventListener('focusin', function () { hold(true); });
    root.addEventListener('focusout', function () { hold(false); });
    // A visitor who starts swiping has taken over; stop competing with them.
    rail.addEventListener('pointerdown', function () { hold(true); });

    document.addEventListener('visibilitychange', sync);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.2 }).observe(root);
    }

    if (typeof reduced.addEventListener === 'function') {
      reduced.addEventListener('change', sync);
    }

    sync();
  }

  function boot() {
    document.querySelectorAll('[data-lrn-gallery]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme editor swaps a section's markup without a page load, so the new
  // copy has never been through boot() and would sit motionless while the
  // merchant is looking straight at it.
  document.addEventListener('shopify:section:load', boot);
})();
